// extracted by mini-css-extract-plugin
export default {"container":"sqior-bed-line-view_container__tn4FT"};